import React from 'react';

interface ArrowRightIconProps extends React.SVGProps<SVGSVGElement> {}

const ArrowRightIcon: React.FC<ArrowRightIconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    stroke="none" // Ensure no stroke for a solid fill
    {...props}
  >
    <path
      d="M8 6 L18 12 L8 18 Z" // Solid triangle pointing right, slightly different coordinates
    />
  </svg>
);

export default ArrowRightIcon;